import { getUrlLanguage } from '~/utils/urlLanguage';

const isBotOrLighthouse = () => {
	if (typeof navigator === 'undefined') return false;
	const ua = navigator.userAgent || '';
	return /Lighthouse|Googlebot|Page Speed|Chrome-Lighthouse|bot|crawler|spider/i.test(ua);
};

const safeRequestIdleCallback = cb => {
	if (typeof window === 'undefined') return;
	if (typeof window.requestIdleCallback === 'function') {
		window.requestIdleCallback(cb);
	} else {
		setTimeout(cb, 0);
	}
};

const appendScript = ({ src, id, dataAttrs = {} }) => {
	const script = document.createElement('script');
	script.src = src;
	script.async = true;
	if (id) script.id = id;
	Object.entries(dataAttrs).forEach(([k, v]) => script.setAttribute(k, v));
	document.head.appendChild(script);
	return script;
};

export const loadFindbarScript = () => {
	if (window.findbarScriptLoaded) return;
	if (globalThis.__BW_ENV__?.REACT_APP_FINDBAR_ENABLED !== 'true') return;
	window.findbarScriptLoaded = true;
	// Pick the Findbar index from the URL path (source of truth) rather than the mutable
	// I18N_LANGUAGE localStorage flag, which can be stale on a cold direct /en/ landing.
	const lang = getUrlLanguage();
	appendScript({
		src: lang === 'el' ? globalThis.__BW_ENV__.REACT_APP_FINDBAR_URL_EL : globalThis.__BW_ENV__.REACT_APP_FINDBAR_URL_EN
	});
};

export const loadChatlingScript = () => {
	if (window.chatlingScriptLoaded) return;
	if (globalThis.__BW_ENV__?.REACT_APP_CHATLING_ENABLED !== 'true') return;
	window.chatlingScriptLoaded = true;
	appendScript({
		src: 'https://chatling.ai/js/embed.js',
		id: 'chatling-embed-script',
		dataAttrs: { 'data-id': '9415273499' }
	});
};

const loadGTM = () => {
	if (window.gtmScriptLoaded) return;
	const id = globalThis.__BW_ENV__?.REACT_APP_GA_TAG_MANAGER_ID;
	if (!id) return;
	window.gtmScriptLoaded = true;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' });
	appendScript({ src: 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id) });
};

const loadSkroutz = () => {
	if (window.skroutzScriptLoaded) return;
	window.skroutzScriptLoaded = true;
	appendScript({ src: 'https://skroutza.skroutz.gr/skroutza.min.js' });
};

const loadKlaviyo = () => {
	if (window.klaviyoScriptLoaded) return;
	const key = (globalThis.__BW_ENV__?.REACT_APP_KLAVIYO_API_KEY || '').replace(/^\/+/, '');
	if (!key) return;
	window.klaviyoScriptLoaded = true;
	appendScript({ src: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(key) });
};

const loadContactPigeon = () => {
	if (window.contactPigeonScriptLoaded) return;
	if (globalThis.__BW_ENV__?.REACT_APP_CONTACT_PIGEON_ENABLED !== 'true') return;
	if (!globalThis.__BW_ENV__?.REACT_APP_CONTACT_PIGEON_URL) return;
	window.contactPigeonScriptLoaded = true;
	appendScript({ src: globalThis.__BW_ENV__.REACT_APP_CONTACT_PIGEON_URL });
};

const loadDeferredScripts = () => {
	setTimeout(() => safeRequestIdleCallback(loadFindbarScript), 1000);

	setTimeout(() => {
		safeRequestIdleCallback(loadGTM);
		safeRequestIdleCallback(loadSkroutz);
		safeRequestIdleCallback(loadKlaviyo);
		safeRequestIdleCallback(loadContactPigeon);
		safeRequestIdleCallback(loadChatlingScript);
	}, 3000);
};

const loadCustomScripts = () => {
	if (typeof window === 'undefined') return;
	if (isBotOrLighthouse()) return;

	if (document.readyState === 'complete') {
		loadDeferredScripts();
	} else {
		window.addEventListener('load', loadDeferredScripts, { once: true });
	}
};

export default loadCustomScripts;
